<template>
  <div>
    <h1>Header 1</h1>
    <h2>Header 2</h2>
    <h3>Header 3</h3>
    <h4>Header 4</h4>
    <h5>Header 5</h5>
    <div>
      <b-button id="primary" variant="primary">Primary</b-button>
      <b-button id="secondary" variant="secondary">Secondary</b-button>
      <b-button id="success" variant="success">Success</b-button>
      <b-button id="danger" variant="danger">Danger</b-button>
      <b-button id="warning" variant="warning">Warning</b-button>
      <b-button id="info" variant="info">Info</b-button>
      <b-button id="light" variant="light">Light</b-button>
      <b-button id="dark" variant="dark">Dark</b-button>
    </div>
    <div>
      <b-button id="outline-primary" variant="outline-primary">Primary</b-button>
      <b-button id="outline-secondary" variant="outline-secondary">Secondary</b-button>
      <b-button id="outline-success" variant="outline-success">Success</b-button>
      <b-button id="outline-danger" variant="outline-danger">Danger</b-button>
      <b-button id="outline-warning" variant="outline-warning">Warning</b-button>
      <b-button id="outline-info" variant="outline-info">Info</b-button>
      <b-button id="outline-light" variant="outline-light">Light</b-button>
      <b-button id="outline-dark" variant="outline-dark">Dark</b-button>
    </div>
    <div>
      <b-button v-b-modal.modal-1>Launch demo modal</b-button>
      <b-modal id="modal-1" title="BootstrapVue">
        <p class="my-4">Hello from modal!</p>
      </b-modal>
    </div>
    <div>
      <b-table head-variant="light" id="table-1" striped hover :items="items" :fields="fields"></b-table>
    </div>
    <div>
      <b-progress :value="55" :max="100" show-progress animated></b-progress>
    </div>
    <div class="text-center">
      <b-spinner variant="warning" class="m-5" style="width: 3rem; height: 3rem;" label="Spinning"></b-spinner>
      <b-spinner variant="warning" class="m-5" style="width: 3rem; height: 3rem;" label="Spinning"></b-spinner>
    </div>
    <div>
      <h4>Form Input</h4>
      <label for="type-text">Text Input:</label>
      <b-form-input id="type-text" type="text"></b-form-input>
      <label for="type-number">number Input:</label>
      <b-form-input id="type-number" type="number"></b-form-input>
    </div>
    <div>
      <h4>Form Select:</h4>
      <b-form-select v-model="selectedOption" :options="options"></b-form-select>
      <div class="mt-3">
        Selected:
        <strong>{{ selectedOption }}</strong>
      </div>
    </div>
    <div>
      <b-form-group label="Radio Buttons">
        <b-form-radio v-model="selectedRadio" name="some-radios" value="A">Option A</b-form-radio>
        <b-form-radio v-model="selectedRadio" name="some-radios" value="B">Option B</b-form-radio>
      </b-form-group>

      <div class="mt-3">
        Selected Radio:
        <strong>{{ selectedRadio }}</strong>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedRadio: "",
      // Note `isActive` is left out and will not appear in the rendered table
      fields: ["first_name", "last_name", "age"],
      items: [
        {
          isActive: true,
          age: 40,
          first_name: "Dickerson",
          last_name: "Macdonald"
        },
        { isActive: false, age: 21, first_name: "Larsen", last_name: "Shaw" },
        { isActive: false, age: 89, first_name: "Geneva", last_name: "Wilson" },
        { isActive: true, age: 38, first_name: "Jami", last_name: "Carney" }
      ],
      selectedOption: null,
      options: [
        { value: null, text: "Please select an option" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true }
      ]
    };
  }
};
</script>

<style scoped>
.btn {
  margin: 0.3rem;
}
div {
  margin: 1rem 0;
}
</style>